/** Max content width for DS Grid / ContentContainer (Figma). */
export const MAX_CONTENT_WIDTH_PX = '1440px' as const;

/**
 * Height of the app-level bar fixed to the bottom of the viewport, published by
 * whoever renders one (today the wizard footer) and read by anything else that
 * positions itself from the bottom edge. Defaults to 0 when no bar is mounted.
 */
export const BOTTOM_BAR_HEIGHT_VAR = '--tundr-bottom-bar-height' as const;

/** `BOTTOM_BAR_HEIGHT_VAR` with its 0px fallback, ready for `calc()`. */
export const bottomBarHeight = `var(${BOTTOM_BAR_HEIGHT_VAR}, 0px)`;
